export const MOBILE_SDK_V1_DASHBOARD_PAGE_MAIN_TITLE_ID = 'mobile-sdk-dashboard-page-main-title';
export const MOBILE_SDK_V1_DASHBOARD_PAGE_NEW_PLATFORM_LINK_ID =
	'mobile-sdk-dashboard-page-new-platform-link';
